<template>
  <div class="pagina ativa" id="paginaImportar">
    <div class="pagina-titulo" style="display:flex;align-items:center;gap:9px;"><FolderInput :size="20" /> Importacao</div>
    <div class="abas-internas">
      <div class="aba-interna" :class="{ ativa: aba === 'mapa' }" @click="aba = 'mapa'">Mapa de Comissao</div>
      <div class="aba-interna" :class="{ ativa: aba === 'contempladas' }" @click="aba = 'contempladas'">Cotas Contempladas (Op.1)</div>
    </div>

    <div class="aba-conteudo" :class="{ ativa: aba === 'mapa' }">
      <div class="area-upload" @click="$refs.arquivoXlsx.click()">
        <div>{{ nomeArquivo || 'Clique para selecionar .xlsx' }}</div>
      </div>
      <input ref="arquivoXlsx" type="file" accept=".xlsx" style="display:none;" @change="selecionarArquivo" /><br>
      <div style="display:flex;gap:10px;flex-wrap:wrap;">
        <button :disabled="!dadosParaImportar || importando" @click="importar">IMPORTAR</button>
        <button :disabled="excluindoMapa" @click="excluirUltimaImportacaoMapa" style="display:inline-flex;align-items:center;gap:5px;background:#c0392b;"><Trash2 :size="14" /> Excluir Ultima Importacao</button>
      </div>
      <div class="status" :class="statusImportar.tipo === 'sucesso' ? 'sucesso' : (statusImportar.tipo === 'erro' ? 'erro-msg' : '')">{{ statusImportar.texto }}</div>
    </div>

    <div class="aba-conteudo" :class="{ ativa: aba === 'contempladas' }">
      <p style="color:#555;font-size:13px;margin-bottom:16px;">Selecione um ou mais PDFs de cotas contempladas. O sistema atualiza automaticamente cotas existentes e insere novas.</p>
      <div class="area-upload" @click="$refs.arquivoPDF.click()">
        <div>{{ pdfFilesQueue.length ? pdfFilesQueue.length + ' arquivo(s) selecionado(s)' : 'Clique para selecionar os PDFs (aceita múltiplos)' }}</div>
      </div>
      <input ref="arquivoPDF" type="file" accept=".pdf" multiple style="display:none;" @change="selecionarPDFs" />
      <div v-if="pdfFilesQueue.length" style="margin-top:14px;display:flex;flex-direction:column;gap:8px;">
        <div v-for="(f, i) in pdfFilesQueue" :key="i" style="display:flex;align-items:center;gap:10px;padding:10px 14px;background:white;border:1px solid #e0e0e0;border-radius:8px;font-size:13px;">
          <div style="width:28px;height:28px;background:#fef3c7;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#92400e;flex-shrink:0;">PDF</div>
          <span style="flex:1;">{{ f.name }}</span>
          <span style="font-size:11px;color:#aaa;">{{ (f.size / 1024).toFixed(0) }} KB</span>
          <span :style="{ fontSize: '11px', color: pdfStatus[i] && pdfStatus[i].cor ? pdfStatus[i].cor : '#aaa' }">{{ (pdfStatus[i] && pdfStatus[i].texto) || 'Aguardando' }}</span>
        </div>
      </div>
      <div style="display:flex;gap:10px;flex-wrap:wrap;">
        <button :disabled="!pdfFilesQueue.length || importandoPdf" style="margin-top:14px;" @click="importarPDFs">IMPORTAR COTAS</button>
        <button :disabled="excluindoCotas" style="display:inline-flex;align-items:center;gap:5px;margin-top:14px;background:#c0392b;" @click="excluirUltimaImportacaoCotas"><Trash2 :size="14" /> Excluir Ultima Importacao</button>
      </div>
      <div class="status" :class="statusImportarPdf.tipo === 'sucesso' ? 'sucesso' : (statusImportarPdf.tipo === 'erro' ? 'erro-msg' : '')">{{ statusImportarPdf.texto }}</div>
    </div>
  </div>
</template>

<script>
import { apiPost, apiDelete } from '../api'
import { FolderInput, Trash2 } from 'lucide-vue-next'

export default {
  components: { FolderInput, Trash2 },
  name: 'PaginaImportacao',
  data() {
    return {
      aba: 'mapa',
      nomeArquivo: '',
      dadosParaImportar: null,
      importando: false,
      statusImportar: { texto: '', tipo: '' },
      pdfFilesQueue: [],
      pdfStatus: [],
      importandoPdf: false,
      statusImportarPdf: { texto: '', tipo: '' },
      excluindoMapa: false,
      excluindoCotas: false
    }
  },
  methods: {
    async excluirUltimaImportacaoMapa() {
      if (!confirm('Excluir todas as linhas da ultima importacao do Mapa de Comissao? Esta acao nao pode ser desfeita.')) return
      this.excluindoMapa = true
      const r = await apiDelete('mapa-comissao/excluir-ultima-importacao')
      this.excluindoMapa = false
      if (r.sucesso) {
        this.statusImportar = { texto: r.total + ' linha(s) excluida(s)' + (r.arquivo ? ' (arquivo ' + r.arquivo + ' liberado para reimportar)' : '') + '.', tipo: 'sucesso' }
      } else {
        this.statusImportar = { texto: r.mensagem || 'Erro ao excluir.', tipo: 'erro' }
      }
    },
    async excluirUltimaImportacaoCotas() {
      if (!confirm('Excluir todas as cotas da ultima importacao? Isso inclui cotas ja existentes que foram atualizadas por ela. Esta acao nao pode ser desfeita.')) return
      this.excluindoCotas = true
      const r = await apiDelete('cotas/excluir-ultima-importacao')
      this.excluindoCotas = false
      if (r.sucesso) {
        this.statusImportarPdf = { texto: (r.total || 0) + ' cota(s) da ultima importacao excluida(s).', tipo: 'sucesso' }
      } else {
        this.statusImportarPdf = { texto: r.mensagem || 'Erro ao excluir.', tipo: 'erro' }
      }
    },
    selecionarArquivo(e) {
      const f = e.target.files[0]
      if (!f) return
      this.nomeArquivo = 'Lendo...'
      this.dadosParaImportar = null
      const r = new FileReader()
      r.onload = (ev) => {
        const d = new Uint8Array(ev.target.result)
        const wb = window.XLSX.read(d, { type: 'array', cellDates: true })
        const sh = wb.Sheets[wb.SheetNames[0]]
        const raw = window.XLSX.utils.sheet_to_json(sh, { header: 1, defval: '', raw: false })
        const cab = raw[0]
        const cc = cab.findIndex(c => c.toString().toUpperCase().trim() === 'CONTRATO')
        const fil = [cab]
        for (let i = 1; i < raw.length; i++) {
          const c = raw[i][cc]
          if (c && c.toString().trim() !== '') fil.push(raw[i])
        }
        this.dadosParaImportar = fil
        this.nomeArquivo = f.name + ' (' + (fil.length - 1) + ' reg.)'
        this._nomeArquivoOriginal = f.name
      }
      r.readAsArrayBuffer(f)
    },
    async importar() {
      if (!this.dadosParaImportar) return
      this.statusImportar = { texto: 'Importando...', tipo: '' }
      this.importando = true
      try {
        const r = await apiPost('mapa-comissao/importar', { dados: this.dadosParaImportar, nomeArquivo: this._nomeArquivoOriginal })
        if (r.sucesso) {
          this.statusImportar = { texto: r.inseridos + ' registros importados!', tipo: 'sucesso' }
        } else {
          this.statusImportar = { texto: r.mensagem, tipo: 'erro' }
          this.importando = false
        }
      } catch (e) {
        this.statusImportar = { texto: 'Erro: ' + e.message, tipo: 'erro' }
        this.importando = false
      }
    },
    selecionarPDFs(e) {
      this.pdfFilesQueue = Array.from(e.target.files || [])
      this.pdfStatus = this.pdfFilesQueue.map(() => ({ texto: 'Aguardando', cor: '#aaa' }))
      this.statusImportarPdf = { texto: '', tipo: '' }
    },
    async extrairTextoPdf(file) {
      const pdfjsLib = await import('pdfjs-dist/legacy/build/pdf')
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js'
      const buf = await file.arrayBuffer()
      const doc = await pdfjsLib.getDocument({ data: buf }).promise
      let texto = ''
      for (let p = 1; p <= doc.numPages; p++) {
        const page = await doc.getPage(p)
        const content = await page.getTextContent()
        const linhas = {}
        content.items.forEach(it => {
          const y = Math.round(it.transform[5])
          if (!linhas[y]) linhas[y] = []
          linhas[y].push(it)
        })
        const ys = Object.keys(linhas).map(Number).sort((a, b) => b - a)
        ys.forEach(y => {
          const itens = linhas[y].sort((a, b) => a.transform[4] - b.transform[4])
          texto += itens.map(it => it.str).join(' ') + '\n'
        })
      }
      return texto
    },
    async importarPDFs() {
      if (!this.pdfFilesQueue.length) return
      this.importandoPdf = true
      this.statusImportarPdf = { texto: '', tipo: '' }
      let totalIns = 0
      let totalAtual = 0
      let totalErr = 0
      for (let i = 0; i < this.pdfFilesQueue.length; i++) {
        const f = this.pdfFilesQueue[i]
        this.pdfStatus.splice(i, 1, { texto: 'Lendo...', cor: '#aaa' })
        try {
          const texto = await this.extrairTextoPdf(f)
          this.pdfStatus.splice(i, 1, { texto: 'Enviando...', cor: '#aaa' })
          const r = await apiPost('cotas/importar-pdf', { texto, nomeArquivo: f.name })
          if (r.sucesso) {
            totalIns += r.inseridos || 0
            totalAtual += r.atualizados || 0
            this.pdfStatus.splice(i, 1, { texto: (r.total || 0) + ' cotas (' + (r.inseridos || 0) + ' novos, ' + (r.atualizados || 0) + ' atualizados)', cor: '#2e7d32' })
          } else {
            totalErr++
            this.pdfStatus.splice(i, 1, { texto: 'Erro: ' + (r.mensagem || 'falha'), cor: '#c0392b' })
          }
        } catch (e) {
          totalErr++
          this.pdfStatus.splice(i, 1, { texto: 'Erro: ' + e.message, cor: '#c0392b' })
        }
      }
      let msg = 'Importação concluída: ' + totalIns + ' novo(s), ' + totalAtual + ' atualizado(s)'
      if (totalErr > 0) msg += ' | ' + totalErr + ' erro(s)'
      this.statusImportarPdf = { texto: msg, tipo: 'sucesso' }
      this.importandoPdf = false
    }
  }
}
</script>
